import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {IDataPartner} from "../../types";
import {
    Checkbox,
    Typography,
    Slider,
    ThemeProvider,
    Chip,
    Select,
    FormControl,
    MenuItem,
    OutlinedInput,
    Box,
    Button
} from "@material-ui/core";
import { createTheme } from '@material-ui/core/styles';
import DateUtils from "@date-io/moment";
import {KeyboardDateTimePicker, MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers";


const muiTheme1 = createTheme({
    overrides:{
        MuiSlider: {
            thumb:{
                color: 'black',
            },
            track: {
                color: '#fd8379'
            },
            rail: {
                color: 'black'
            }
        }
    }
});

interface IProps {
    partnerData: IDataPartner
    filtrosTipos: number[]
    filtroParcelas: number[]
    filtroSuperficie: number[]
    filtroCultivos: string[]
    filtroEstado: number[]
    filtroCreacionInicio: Date | null
    filtroCreacionFin: Date | null
    filtroExpedicionInicio: Date | null
    filtroExpedicionFin: Date | null
    filtroUltimaConexionInicio: Date | null
    filtroUltimaConexionFin: Date | null
    setFiltroTipos(tipos: number[]): void
    setFiltroParcelas(parcelas: number[]): void
    setFiltrosuperficie(superficie: number[]): void
    setFiltroCultivos(cultivos: string[]): void
    setFiltroEstado(estado: number[]): void
    setFiltroCreacionInicio(fecha: Date | null): void
    setFiltroCreacionFin(fecha: Date | null): void
    setFiltroExpedicionInicio(fecha: Date | null): void
    setFiltroExpedicionFin(fecha: Date | null): void
    setFiltroUltimaConexionInicio(fecha: Date | null): void
    setFiltroUltimaConexionFin(fecha: Date | null): void
    setFiltrosActuaizados(actualizado: boolean): void
}

interface Istate {
    otro: boolean
    checkBasico: boolean
    checkAvanzado: boolean
    checkProfesional: boolean
    checkOtro: boolean
    maxParcelas: number
    maxSuperficie: number
    minSuperficie: number
    valueParcelas: number[]
    valueSuperficie: number[]
    cultivos: string[]
    checkActivos: boolean
    checkInactivos: boolean
}


class FiltersMenu extends React.Component<IProps, Istate> {

    state:Istate = {
        otro: false,
        checkBasico: false,
        checkAvanzado: false,
        checkProfesional: false,
        checkOtro: false,
        maxParcelas: -1,
        maxSuperficie: -1,
        minSuperficie: -1,
        valueParcelas: [0, 0],
        valueSuperficie: [0, 0],
        cultivos: [] as string[],
        checkActivos: false,
        checkInactivos: false,
    }

    componentDidMount() {
        for (let filtro of this.props.filtrosTipos) {
            if (filtro === 1) this.setState({checkBasico: true})
            if (filtro === 2) this.setState({checkAvanzado: true})
            if (filtro === 3) this.setState({checkProfesional: true})
            if (filtro === 4) this.setState({checkOtro: true})
        }
        for (let filtro of this.props.filtroEstado) {
            if (filtro === 1) this.setState({checkActivos: true})
            if (filtro === 0) this.setState({checkInactivos: true})
        }

        if (!this.props.partnerData.hasOwnProperty("plots")) {
            setTimeout(() => this.componentDidMount(), 200)
            return
        }
        if (!this.props.partnerData.hasOwnProperty("users")) {
            setTimeout(() => this.componentDidMount(), 200)
            return
        }

        let maxParcelas = 0
        let minSuperficie = -1
        let maxSuperficie = -1
        let cultivos = [] as string[]
        for (let client of Object.keys(this.props.partnerData.plots)) {
            if (this.props.partnerData.plots[client].length > maxParcelas) {
                maxParcelas = this.props.partnerData.plots[client].length
            }
            let superficie = 0
            for (let parcela of this.props.partnerData.plots[client]) {
                superficie += parcela["superficie"] as number
                if (!cultivos.includes(parcela["cultivo"] as string)) cultivos.push(parcela["cultivo"] as string)
            }

            superficie = Math.round(superficie/100)/100

            if (maxSuperficie === -1 || superficie > maxSuperficie) {
                maxSuperficie = superficie
            }
            if (minSuperficie === -1 || superficie < minSuperficie) {
                minSuperficie = superficie
            }
        }

        minSuperficie = Math.round(minSuperficie)
        maxSuperficie = Math.round(maxSuperficie) + 1

        if (this.props.filtroParcelas.length === 0) {
            this.setState({valueParcelas: [0, maxParcelas]})
            this.props.setFiltroParcelas([0, maxParcelas])
        } else {
            this.setState({valueParcelas: this.props.filtroParcelas})
        }

        if (this.props.filtroSuperficie.length === 0) {
            this.setState({valueSuperficie: [minSuperficie, maxSuperficie]})
            this.props.setFiltrosuperficie([minSuperficie, maxSuperficie])
        } else {
            this.setState({valueSuperficie: this.props.filtroSuperficie})
        }

        this.setState({
            maxParcelas: maxParcelas,
            maxSuperficie: maxSuperficie,
            minSuperficie: minSuperficie,
            cultivos: cultivos
        })

        let users_basico = [] as string[]
        let users_avanzado = [] as string[]
        let users_profesional = [] as string[]
        let users_otro = [] as string[]

        for (let user of this.props.partnerData.users) {
            if (user.level === 1) {
                users_basico.push(user.nombre as string)
            } else if (user.level === 2) {
                users_avanzado.push(user.nombre as string)
            } else if (user.level === 3) {
                users_profesional.push(user.nombre as string)
            } else {
                users_otro.push(user.nombre as string)
            }
        }

        if (users_otro.length > 0) {
            this.setState({otro: true})
        }

    }

    valueText = (value: number): string => {
        return value.toString();
    }

    render() {


        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: "center",
                    width: '100%',
                    height: '100%',
                    overflowY: "auto"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <Typography
                    style={{
                        fontFamily: "Poppins",
                        marginTop: 20,
                        fontSize: 14,
                        fontWeight: "bold"
                    }}
                >
                    Tipo de Cliente
                </Typography>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 'calc(100% - 40px)',
                        justifyContent: "space-around"
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                        >
                            <Checkbox
                                style={{color: "#000", transform: "scale(0.8)"}}
                                checked={this.state.checkBasico}
                                onClick={() => {
                                    this.props.setFiltrosActuaizados(false)
                                    this.setState({checkBasico: !this.state.checkBasico})
                                    let nuevosFiltros = [] as number[]
                                    if (this.props.filtrosTipos.includes(1)) {
                                        for (let filtro of this.props.filtrosTipos) {
                                            if (filtro === 1) continue
                                            nuevosFiltros.push(filtro)
                                        }
                                    } else {
                                        nuevosFiltros = this.props.filtrosTipos
                                        nuevosFiltros.push(1)
                                    }
                                    this.props.setFiltroTipos(nuevosFiltros)
                                    this.props.setFiltrosActuaizados(true)
                                }}
                            />
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14,
                                    marginLeft: -5
                                }}
                            >
                                Básico
                            </Typography>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                        >
                            <Checkbox
                                style={{color: "#000", transform: "scale(0.8)"}}
                                checked={this.state.checkProfesional}
                                onClick={() => {
                                    this.props.setFiltrosActuaizados(false)
                                    this.setState({checkProfesional: !this.state.checkProfesional})
                                    let nuevosFiltros = [] as number[]
                                    if (this.props.filtrosTipos.includes(3)) {
                                        for (let filtro of this.props.filtrosTipos) {
                                            if (filtro === 3) continue
                                            nuevosFiltros.push(filtro)
                                        }
                                    } else {
                                        nuevosFiltros = this.props.filtrosTipos
                                        nuevosFiltros.push(3)
                                    }
                                    this.props.setFiltroTipos(nuevosFiltros)
                                    this.props.setFiltrosActuaizados(true)
                                }}
                            />
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14,
                                    marginLeft: -5
                                }}
                            >
                                Profesional
                            </Typography>
                        </div>

                    </div>


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%"
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                        >
                            <Checkbox
                                style={{color: "#000", transform: "scale(0.8)"}}
                                checked={this.state.checkAvanzado}
                                onClick={() => {
                                    this.props.setFiltrosActuaizados(false)
                                    this.setState({checkAvanzado: !this.state.checkAvanzado})
                                    let nuevosFiltros = [] as number[]
                                    if (this.props.filtrosTipos.includes(2)) {
                                        for (let filtro of this.props.filtrosTipos) {
                                            if (filtro === 2) continue
                                            nuevosFiltros.push(filtro)
                                        }
                                    } else {
                                        nuevosFiltros = this.props.filtrosTipos
                                        nuevosFiltros.push(2)
                                    }
                                    this.props.setFiltroTipos(nuevosFiltros)
                                    this.props.setFiltrosActuaizados(true)
                                }}
                            />
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14,
                                    marginLeft: -5
                                }}
                            >
                                Avanzado
                            </Typography>
                        </div>


                        {this.state.otro &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                }}
                            >
                                <Checkbox
                                    style={{color: "#000", transform: "scale(0.8)"}}
                                    checked={this.state.checkOtro}
                                    onClick={() => {
                                        this.props.setFiltrosActuaizados(false)
                                        this.setState({checkOtro: !this.state.checkOtro})
                                        let nuevosFiltros = [] as number[]
                                        if (this.props.filtrosTipos.includes(4)) {
                                            for (let filtro of this.props.filtrosTipos) {
                                                if (filtro === 4) continue
                                                nuevosFiltros.push(filtro)
                                            }
                                        } else {
                                            nuevosFiltros = this.props.filtrosTipos
                                            nuevosFiltros.push(4)
                                        }
                                        this.props.setFiltroTipos(nuevosFiltros)
                                        this.props.setFiltrosActuaizados(true)
                                    }}
                                />
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14,
                                        marginLeft: -5
                                    }}
                                >
                                    Otro
                                </Typography>
                            </div>
                        }

                    </div>

                </div>


                <div
                    style={{
                        width: '80%',
                        height: 0,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: '#4b484a',
                        alignSelf: "center",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                />

                <Typography
                    style={{
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "bold"
                    }}
                >
                    Número de Parcelas
                </Typography>

                <div
                    style={{
                        width: "80%"
                    }}
                >
                    <ThemeProvider theme={muiTheme1}>
                        {this.state.maxParcelas != -1 &&
                            <Slider
                                getAriaLabel={this.valueText}
                                valueLabelDisplay="auto"
                                value={this.state.valueParcelas}
                                step={1}
                                marks
                                min={0}
                                max={this.state.maxParcelas}
                                onChange={(event, value) => {
                                    this.setState({valueParcelas: value as number[]})
                                    this.props.setFiltroParcelas(value as number[])
                                }}
                            />
                        }
                    </ThemeProvider>
                </div>

                <div
                    style={{
                        width: '80%',
                        height: 0,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: '#4b484a',
                        alignSelf: "center",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                />

                <Typography
                    style={{
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "bold"
                    }}
                >
                    Superficie Total (Ha)
                </Typography>

                <div
                    style={{
                        width: "80%"
                    }}
                >
                    <ThemeProvider theme={muiTheme1}>
                        {this.state.maxSuperficie != -1 &&
                            <Slider
                                getAriaLabel={this.valueText}
                                valueLabelDisplay="auto"
                                value={this.state.valueSuperficie}
                                step={1}
                                min={this.state.minSuperficie}
                                max={this.state.maxSuperficie}
                                onChange={(event, value) => {
                                    this.setState({valueSuperficie: value as number[]})
                                    this.props.setFiltrosuperficie(value as number[])
                                }}
                            />
                        }
                    </ThemeProvider>
                </div>

                <div
                    style={{
                        width: '80%',
                        height: 0,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: '#4b484a',
                        alignSelf: "center",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                />

                <Typography
                    style={{
                        fontFamily: "Poppins",
                        fontSize: 14,
                        marginBottom: 10,
                        fontWeight: "bold"
                    }}
                >
                    Cultivos
                </Typography>

                <FormControl style={{width: "80%"}}>
                    <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        value={this.props.filtroCultivos}
                        onChange={(e) => {
                            this.props.setFiltroCultivos(e.target.value as string[])

                        }}
                        input={<OutlinedInput id="select-multiple-chip" label="Chip"/>}
                        renderValue={() => (
                            <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                                {this.props.filtroCultivos.map((cultivo) => (
                                    <Chip key={cultivo} label={cultivo.replace(/_/gi, ' ')}/>
                                ))}
                            </Box>
                        )}
                    >
                        {this.state.cultivos.map((cultivo) => (
                            <MenuItem
                                key={cultivo}
                                value={cultivo}
                            >
                                {cultivo.replace(/_/gi, ' ')}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <div
                    style={{
                        width: '80%',
                        height: 0,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: '#4b484a',
                        alignSelf: "center",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                />

                <Typography
                    style={{
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "bold"
                    }}
                >
                    Estado
                </Typography>


                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 'calc(100% - 40px)',
                        justifyContent: "space-around"
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                        >
                            <Checkbox
                                style={{color: "#000", transform: "scale(0.8)"}}
                                checked={this.state.checkActivos}
                                onClick={() => {
                                    this.props.setFiltrosActuaizados(false)
                                    this.setState({checkActivos: !this.state.checkActivos})
                                    let nuevosFiltros = [] as number[]
                                    if (this.props.filtroEstado.includes(1)) {
                                        for (let filtro of this.props.filtroEstado) {
                                            if (filtro === 1) continue
                                            nuevosFiltros.push(filtro)
                                        }
                                    } else {
                                        nuevosFiltros = this.props.filtroEstado
                                        nuevosFiltros.push(1)
                                    }
                                    this.props.setFiltroEstado(nuevosFiltros)
                                    this.props.setFiltrosActuaizados(true)
                                }}
                            />
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14,
                                    marginLeft: -5
                                }}
                            >
                                Confirmados
                            </Typography>
                        </div>

                    </div>


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%"
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                        >
                            <Checkbox
                                style={{color: "#000", transform: "scale(0.8)"}}
                                checked={this.state.checkInactivos}
                                onClick={() => {
                                    this.props.setFiltrosActuaizados(false)
                                    this.setState({checkInactivos: !this.state.checkInactivos})
                                    let nuevosFiltros = [] as number[]
                                    if (this.props.filtroEstado.includes(0)) {
                                        for (let filtro of this.props.filtroEstado) {
                                            if (filtro === 0) continue
                                            nuevosFiltros.push(filtro)
                                        }
                                    } else {
                                        nuevosFiltros = this.props.filtroEstado
                                        nuevosFiltros.push(0)
                                    }
                                    this.props.setFiltroEstado(nuevosFiltros)
                                    this.props.setFiltrosActuaizados(true)
                                }}
                            />
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14,
                                    marginLeft: -5
                                }}
                            >
                                No confirmados
                            </Typography>
                        </div>

                    </div>

                </div>

                <div
                    style={{
                        width: '80%',
                        height: 0,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: '#4b484a',
                        alignSelf: "center",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                />

                <Typography
                    style={{
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "bold"
                    }}
                >
                    Fecha Creación
                </Typography>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "80%"
                    }}
                >
                    <div style={{width: 'calc(50% - 10px)'}}>
                        <MuiPickersUtilsProvider
                            utils={DateUtils}
                        >
                            <KeyboardDatePicker
                                variant="inline"
                                label="Inicio"
                                value={this.props.filtroCreacionInicio}
                                onChange={(f) => {
                                    if (f !== null) {
                                        this.props.setFiltroCreacionInicio(f.toDate())
                                    } else {
                                        this.props.setFiltroCreacionInicio(null)
                                    }

                                }}
                                format="YYYY/MM/DD"
                            />
                        </MuiPickersUtilsProvider>
                    </div>

                    <div style={{width: 'calc(50% - 10px)'}}>
                        <MuiPickersUtilsProvider
                            utils={DateUtils}
                        >
                            <KeyboardDatePicker
                                variant="inline"
                                label="Fin"
                                value={this.props.filtroCreacionFin}
                                onChange={(f) => {
                                    if (f !== null) {
                                        this.props.setFiltroCreacionFin(f.toDate())
                                    } else {
                                        this.props.setFiltroCreacionFin(null)
                                    }

                                }}
                                format="YYYY/MM/DD"
                            />
                        </MuiPickersUtilsProvider>
                    </div>

                </div>


                <div
                    style={{
                        width: '80%',
                        height: 0,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: '#4b484a',
                        alignSelf: "center",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                />

                <Typography
                    style={{
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "bold"
                    }}
                >
                    Fecha Expedición
                </Typography>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "80%"
                    }}
                >
                    <div style={{width: 'calc(50% - 10px)'}}>
                        <MuiPickersUtilsProvider
                            utils={DateUtils}
                        >
                            <KeyboardDatePicker
                                variant="inline"
                                label="Inicio"
                                value={this.props.filtroExpedicionInicio}
                                onChange={(f) => {
                                    if (f !== null) {
                                        this.props.setFiltroExpedicionInicio(f.toDate())
                                    } else {
                                        this.props.setFiltroExpedicionInicio(null)
                                    }

                                }}
                                format="YYYY/MM/DD"
                            />
                        </MuiPickersUtilsProvider>
                    </div>

                    <div style={{width: 'calc(50% - 10px)'}}>
                        <MuiPickersUtilsProvider
                            utils={DateUtils}
                        >
                            <KeyboardDatePicker
                                variant="inline"
                                label="Fin"
                                value={this.props.filtroExpedicionFin}
                                onChange={(f) => {
                                    if (f !== null) {
                                        this.props.setFiltroExpedicionFin(f.toDate())
                                    } else {
                                        this.props.setFiltroExpedicionFin(null)
                                    }

                                }}
                                format="YYYY/MM/DD"
                            />
                        </MuiPickersUtilsProvider>
                    </div>

                </div>


                <div
                    style={{
                        width: '80%',
                        height: 0,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: '#4b484a',
                        alignSelf: "center",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                />

                <Typography
                    style={{
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "bold"
                    }}
                >
                    Última Conexión
                </Typography>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "80%"
                    }}
                >
                    <div style={{width: 'calc(50% - 10px)'}}>
                        <MuiPickersUtilsProvider
                            utils={DateUtils}
                        >
                            <KeyboardDatePicker
                                variant="inline"
                                label="Inicio"
                                value={this.props.filtroUltimaConexionInicio}
                                onChange={(f) => {
                                    if (f !== null) {
                                        this.props.setFiltroUltimaConexionInicio(f.toDate())
                                    } else {
                                        this.props.setFiltroUltimaConexionInicio(null)
                                    }

                                }}
                                format="YYYY/MM/DD"
                            />
                        </MuiPickersUtilsProvider>
                    </div>

                    <div style={{width: 'calc(50% - 10px)'}}>
                        <MuiPickersUtilsProvider
                            utils={DateUtils}
                        >
                            <KeyboardDatePicker
                                variant="inline"
                                label="Fin"
                                value={this.props.filtroUltimaConexionFin}
                                onChange={(f) => {
                                    if (f !== null) {
                                        this.props.setFiltroUltimaConexionFin(f.toDate())
                                    } else {
                                        this.props.setFiltroUltimaConexionFin(null)
                                    }

                                }}
                                format="YYYY/MM/DD"
                            />
                        </MuiPickersUtilsProvider>
                    </div>

                </div>

                <div
                    style={{
                        width: '80%',
                        height: 0,
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderColor: '#4b484a',
                        alignSelf: "center",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                />

                <Button
                    variant={"outlined"}
                    style={{
                        textTransform: "none",
                        marginBottom: 40
                    }}
                    onClick={() => {

                        this.props.setFiltrosActuaizados(false)
                        this.props.setFiltroTipos([])
                        this.props.setFiltroParcelas([])
                        this.props.setFiltrosuperficie([])
                        this.props.setFiltroCultivos([])
                        this.props.setFiltroEstado([])
                        this.props.setFiltroCreacionInicio(null)
                        this.props.setFiltroCreacionFin(null)
                        this.props.setFiltroExpedicionInicio(null)
                        this.props.setFiltroExpedicionFin(null)
                        this.props.setFiltroUltimaConexionInicio(null)
                        this.props.setFiltroUltimaConexionFin(null)
                        this.props.setFiltrosActuaizados(true)

                        this.setState({
                            otro: false,
                            checkBasico: false,
                            checkAvanzado: false,
                            checkProfesional: false,
                            checkOtro: false,
                            maxParcelas: -1,
                            maxSuperficie: -1,
                            minSuperficie: -1,
                            valueParcelas: [0, 0],
                            valueSuperficie: [0, 0],
                            cultivos: [] as string[],
                            checkActivos: false,
                            checkInactivos: false
                        })

                        setTimeout(() => this.componentDidMount(), 100)
                    }}
                >

                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            fontSize: 14,
                            fontWeight: "bold"
                        }}
                    >
                        Restablecer Filtros
                    </Typography>

                </Button>


            </div>
        )

    }
}

const mapStateToProps = (state: IStore) => ({
    partnerData: state.partner.dataPartner,
    filtrosTipos: state.partner.filtroTipos,
    filtroParcelas: state.partner.filtroParcelas,
    filtroSuperficie: state.partner.filtroSuperficie,
    filtroCultivos: state.partner.filtroCultivos,
    filtroEstado: state.partner.filtroEstado,
    filtroCreacionInicio: state.partner.filtroCreacionInicio,
    filtroCreacionFin: state.partner.filtroCreacionFin,
    filtroExpedicionInicio: state.partner.filtroExpedicionInicio,
    filtroExpedicionFin: state.partner.filtroExpedicionFin,
    filtroUltimaConexionInicio: state.partner.filtroUltimaConexionInicio,
    filtroUltimaConexionFin: state.partner.filtroUltimaConexionFin
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setFiltroTipos: (tipos: number[]) => dispatch({type: "set-filtro-tipos", tipos}),
    setFiltroParcelas: (parcelas: number[]) => dispatch({type: "set-filtro-parcelas", parcelas}),
    setFiltrosuperficie: (superficie: number[]) => dispatch({type: "set-filtro-superficie", superficie}),
    setFiltroCultivos: (cultivos: string[]) => dispatch({type: "set-filtro-cultivos", cultivos}),
    setFiltroEstado: (estado: number[]) => dispatch({type: "set-filtro-estado", estado}),
    setFiltroCreacionInicio: (fecha: Date | null) => dispatch({type: "set-filtro-creacion-inicio", fecha}),
    setFiltroCreacionFin: (fecha: Date | null) => dispatch({type: "set-filtro-creacion-fin", fecha}),
    setFiltroExpedicionInicio: (fecha: Date | null) => dispatch({type: "set-filtro-expedicion-inicio", fecha}),
    setFiltroExpedicionFin: (fecha: Date | null) => dispatch({type: "set-filtro-expedicion-fin", fecha}),
    setFiltroUltimaConexionInicio: (fecha: Date | null) => dispatch({type: "set-filtro-ultima-conexion-inicio", fecha}),
    setFiltroUltimaConexionFin: (fecha: Date | null) => dispatch({type: "set-filtro-ultima-conexion-fin", fecha}),
    setFiltrosActuaizados: (actualizado: boolean) => dispatch({type: "set-filtros-actualizados", actualizado}),
});

export default connect(mapStateToProps, mapDispatchToProps)(FiltersMenu);
